<template>
    <div class="page-nav" v-if="nav">
        <template v-if="nav.prev && nav.prev.title">
            <a
                v-if="nav.prev"
                :href="nav.prev.url"
                :title="nav.prev.title"
                class="page-nav__btn page-nav__btn--prev"
            >
                <z-icon name="btn-arrow" width="16" height="16"></z-icon>
            </a>
            <a
                href="javascript:void(0)"
                class="page-nav__btn page-nav__btn--disabled page-nav__btn--prev"
                v-else
            >
                <z-icon name="btn-arrow" width="16" height="16"></z-icon>
            </a>
        </template>

        <button
            class="page-nav__btn page-nav__btn--up hide-me--default show-me--v-tablet"
            type="button"
            @click="scrollTop"
        >
            <z-icon name="btn-arrow" width="16" height="16"></z-icon>
        </button>

        <template v-if="nav.next && nav.next.title">
            <a
                :href="nav.next.url"
                :title="nav.next.title"
                class="page-nav__btn page-nav__btn--next"
                v-if="nav.next"
            >
                <z-icon name="btn-arrow" width="16" height="16"></z-icon>
            </a>
            <a
                href="javascript:void(0)"
                class="page-nav__btn page-nav__btn--disabled page-nav__btn--next"
                v-else
            >
                <z-icon name="btn-arrow" width="16" height="16"></z-icon>
            </a>
        </template>

    </div>
</template>

<script>
import Velocity from 'velocity-animate'

export default {
    computed: {
        nav () {
            return this.$root.app.components['page-nav'] ? this.$root.app.components['page-nav'] : null
        }
    },
    methods: {
        scrollTop () {
            Velocity(document.body, 'scroll', { offset: 0 })
        }
    }
}
</script>

<style lang="scss">
.page-nav {
    display: flex;
    width: 100%;
    justify-content: center;

    &__btn {
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 64px;
        height: 64px;
        border-radius: 50%;
        margin-right: $token-spacers-xs;
        position: relative;
        border: none;
        outline: none;
        cursor: pointer;

        @include breakpoint (v-tablet) {
            width: 48px;
            height: 48px;

            .z-icon {
                width: 12px !important;
                height: 12px !important;
            }
        }

        @include breakpoint (mobile) {
            width: 40px;
            height: 40px;
        }

        &:hover {
            &:before {
                border-left-color: $token-colors-primary;
                border-top-color: $token-colors-primary;
                border-right-color: #FBB92F;
                border-bottom-color: #E42213;
            }

            &:after {
                opacity: 0;
            }
        }

        &:active {
            &:before {
                border-right-color: #E42213;
                border-bottom-color: #FBB92F;
                transform: rotate(225deg);
            }
        }

        &:after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            border: 1px solid $token-colors-black-20;
            transition: opacity $transition;
        }

        &:before {
            position: absolute;
            transform: rotate(45deg);
            content: '';
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border: 4px solid $token-colors-white;
            border-radius: 50%;
            transition: border $transition, transform 0.1s linear;
            background: $token-colors-white;;
        }

        &:last-child {
            margin-right: 0;
        }

        .z-icon {
            position: relative;
            z-index: 3;
        }

        &--up {
            padding: 0;
            .z-icon {
                transform: rotate(-90deg);
            }
        }

        &--prev {
            .z-icon {
                transform: scale(-1, 1);
            }
        }

        &--disabled {
            pointer-events: none;

            .z-icon {
                path {
                    fill: $token-colors-black-40;
                }
            }
        }

    }
}
</style>
